import { Table, TableContainer, TableCell, TableBody, TableHead, TableRow, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const PREFIX = 'MonthlyCostStatusFinancialSummary';

const classes = {
  tableHead: `${PREFIX}-tableHead`,
  groupHeader: `${PREFIX}-groupHeader`,
  groupHeaderRight: `${PREFIX}-groupHeaderRight`,
  headerCell: `${PREFIX}-headerCell`,
  borderLeft: `${PREFIX}-borderLeft`,
  borderRight: `${PREFIX}-borderRight`,
  borderRightLight: `${PREFIX}-borderRightLight`,
  bodyCell: `${PREFIX}-bodyCell`,
  flexEnd: `${PREFIX}-flexEnd`
};

const Root = styled('div')(() => ({
  [`& .${classes.tableHead}`]: {
    backgroundColor: '#003865',
  },

  [`& .${classes.groupHeader}`]: {
    color: 'white !important',
    width: '30em',
    borderLeft: '0.5px solid gray',
    borderRight: '0.5px solid gray',
    borderBottom: '0.5px solid gray !important',
    textAlign: 'center',
    padding: '8px 12px !important',
    lineHeight: '1.2 !important',
  },

  [`& .${classes.groupHeaderRight}`]: {
    color: 'white !important',
    width: '30em',
    borderBottom: '0.5px solid gray !important',
    borderRight: '0.5px solid gray',
    textAlign: 'center',
    padding: '8px 16px !important',
    lineHeight: '1.2 !important',
  },

  [`& .${classes.headerCell}`]: {
    color: 'white !important',
    width: '15em',
    textAlign: 'right',
    padding: '8px 12px !important',
    lineHeight: '1.2 !important',
  },

  [`& .${classes.borderLeft}`]: {
    borderLeft: '0.5px solid gray',
  },

  [`& .${classes.borderRight}`]: {
    borderRight: '0.5px solid gray',
  },

  [`& .${classes.borderRightLight}`]: {
    borderRight: '0.5px solid gray',
  },

  [`& .${classes.bodyCell}`]: {
    width: '15em',
    textAlign: 'right',
    padding: '6px 12px !important',
    whiteSpace: 'nowrap',
    minWidth: '120px',
  },

  [`& .${classes.flexEnd}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 0.5,
    minHeight: 0,
    lineHeight: 1.2,
  },

  // Target all financial-summary-body Typography components
  [`& .financial-summary-body`]: {
    fontFamily: 'Titillium Web, sans-serif !important',
    padding: '0 !important',
    margin: '0 !important',
    lineHeight: '1.1 !important',
  },

  // Add padding to the first column (title column) TableCell
  [`& .MuiTableCell-root.financial-summary-body`]: {
    padding: '6px 12px !important',
    textAlign: 'left',
  }
}));

const MonthlyCostStatusFinancialSummary = ({ tableHeaders, tableData }) => {

  return (
    <Root>
      <Typography variant="subtitle1">Financial Summary</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead className={classes.tableHead}>
            <TableRow style={{ backgroundColor: '#062b45' }}>
              <TableCell className={classes.groupHeader} rowSpan={1} align="left"></TableCell>
              <TableCell className={classes.groupHeader} align="center" colSpan={2}>Current</TableCell>
              <TableCell className={classes.groupHeaderRight} align="center" colSpan={2}>MOM Change</TableCell>
            </TableRow>
            {/* <TableRow style={{ backgroundColor: '#093d61' }}>
              <TableCell className={classes.groupHeader} rowSpan={1} align="left"></TableCell>
              <TableCell className={`${classes.headerCell} ${classes.borderLeft} ${classes.borderRightLight}`} align="center">$</TableCell>
              <TableCell className={`${classes.headerCell} ${classes.borderRight}`} align="center">%</TableCell>
              <TableCell className={`${classes.headerCell} ${classes.borderRightLight}`} align="center">$</TableCell>
              <TableCell className={`${classes.headerCell} ${classes.borderRight}`} align="center">%</TableCell>
            </TableRow> */}
          </TableHead>
          <TableBody>
            {tableData && tableData.map((row) => {
              const sectionBorder = row.sectionEnd ? '2px dashed #bbb' : undefined;
              return (
                <TableRow key={row.id} sx={sectionBorder ? { '& td': { borderBottom: sectionBorder } } : undefined}>
                  <TableCell
                    className="financial-summary-body"
                    sx={row.indented ? { paddingLeft: '28px !important' } : undefined}
                  >
                    {row.title}
                  </TableCell>
                  <TableCell className={`${classes.bodyCell} ${classes.borderLeft} ${classes.borderRightLight}`}>
                    <Typography variant="body2" className="financial-summary-body">
                      {row.value}
                    </Typography>
                  </TableCell>
                  <TableCell className={`${classes.bodyCell} ${classes.borderRight}`}>
                    <Typography variant="body2" className="financial-summary-body">
                      {row.value_percent}
                    </Typography>
                  </TableCell>
                  <TableCell className={`${classes.bodyCell} ${classes.borderRightLight}`}>
                    <Typography variant="body2" className="financial-summary-body" classes={{ root: classes.flexEnd }}>
                      {row.mom_change_amount}
                      {(row.arrow && row.arrow === 'green') && (
                        <ArrowUpwardIcon fontSize="small" sx={{ color: 'green', ml: 0.5 }} />
                      )}
                      {(row.arrow && row.arrow === 'red') && (
                        <ArrowDownwardIcon fontSize="small" sx={{ color: 'red', ml: 0.5 }} />
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell className={`${classes.bodyCell} ${classes.borderRight}`}>
                    <Typography variant="body2" className="financial-summary-body" classes={{ root: classes.flexEnd }}>
                      {row.mom_change_percent}
                      {(row.arrow && row.arrow === 'green') && (
                        <ArrowUpwardIcon fontSize="small" sx={{ color: 'green', ml: 0.5 }} />
                      )}
                      {(row.arrow && row.arrow === 'red') && (
                        <ArrowDownwardIcon fontSize="small" sx={{ color: 'red', ml: 0.5 }} />
                      )}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Root>
  );
};

export default MonthlyCostStatusFinancialSummary;
